import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetHighRiskBankCard extends Http {
  [x: string]: any
  // 高危银行卡
  public async getHighRiskBankCard(data: NLoginApi.HighRiskBankCardRequestData) {
    return await super.request<NLoginApi.HighRiskBankCardResponse>({
      url: '/crossbowSystem/getHighRiskBankCard',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getHighRiskBankCardExport(data: NLoginApi.HighRiskBankCardRequestData) {
    return await super.request<NLoginApi.HighRiskBankCardResponse>({
      url: '/crossbowSystem/exportBankCardExcel',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data,
      responseType: 'blob'
    })
  }
}

export default GetHighRiskBankCard
